/**
 * ApiError Class.
 *
 * @typedef {Object} ApiError
 *
 * @module ApiError
 **/
export default class ApiError extends Error {

  /**
   * @constructor
   * @this {ApiError}
   *
   * @param {Object} Error - Error information.
   **/
  constructor({ statusCode, axiosMessage, serverMessage, stack }) {
    super('API Error');

    this.statusCode = statusCode;
    this.axiosMessage = axiosMessage;
    this.serverMessage = serverMessage;
    this.stack = stack;
  }
}
